import React, { useState } from 'react'
import { Panel, SelectPicker, DatePicker, Input, Row, Col } from 'rsuite'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function AssetCountingSupplyOfficerForm({
  schema,
  loading,
  onSearch = () => {},
  isSupplyOfficer,
  ...props
}) {
  const [stockCountNo, setStockCountNo] = useState()
  // const [closureStatus, setClosureStatus] = useState()
  const [stockCountStatus, setStockCountStatus] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [projectCode, setProjectCode] = useState()

  const _projectCode = sessionGetItemStr('projectCode')

  const handleOnSearch = () => {
    const request = {
      projectCode: isSupplyOfficer ? projectCode : _projectCode,
      stockCountNo: stockCountNo || '',
      stockCountStatus: stockCountStatus || 0,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
    }

    onSearch(request)
  }

  const handleCancelSearch = () => {
    setStockCountNo('')
    setStockCountStatus(0)
    setStartDate('')
    setEndDate('')
    setProjectCode('')

    if (isSupplyOfficer) {
      onSearch({})
    } else {
      onSearch({ projectCode: projectCode })
    }
  }

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.stockCountNo.label}
            <Input
              placeholder={schema.stockCountNo.hint || schema.stockCountNo.label}
              value={stockCountNo}
              onChange={(value) => {
                setStockCountNo(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.stockCountStatus.label}
            <SelectPicker
              searchable={false}
              data={schema.stockCountStatus.options}
              value={stockCountStatus}
              block
              placeholder={`เลือก${schema.stockCountStatus.label || ''}`}
              onChange={(value) => {
                setStockCountStatus(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.startDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={startDate}
              disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
              onChange={(value) => {
                setStartDate(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.endDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={endDate}
              disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
              onChange={(value) => {
                setEndDate(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        {isSupplyOfficer && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.projectCode.label}
              <Input
                placeholder={schema.projectCode.hint || schema.projectCode.label}
                value={projectCode}
                onChange={(value) => {
                  setProjectCode(value)
                }}
              />
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                handleOnSearch()
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                handleCancelSearch()
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
